// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1561":"8f3584aa","8594":"8f3584aa"}[chunkId] + ".chunk.css";
};